import { Controller } from "@hotwired/stimulus"

const MFA_CODE_LENGTH = 6

export default class extends Controller {
  handleInput() {
    const currentValue = this.element.value
    if (!currentValue) { return }
    if (currentValue.length != MFA_CODE_LENGTH) { return }

    this.element.closest("form").requestSubmit()
  }
}
